module.exports = __webpack_public_path__ + "static/media/leaf.1428bb47.svg";